export default __webpack_public_path__ + "static/media/infoIcon.ae56c062.PNG";